export default __webpack_public_path__ + "static/media/referenced_payment.af1177e8.png";